const ISOStringToDate = isoString => {
  const date = new Date(isoString);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};

export default ISOStringToDate;
